<div *ngFor="let errorItem of getErrors()">
	<p class="c-text c-text--s3 c-text--sm" [ngClass]="{'u-ost-sm': !noOffset}" *ngIf="errorItem.required">
		{{ fieldName }} {{ 'Modal.Form.Error.Required' | translate }}
	</p>
	<p class="c-text c-text--s3 c-text--sm" [ngClass]="{'u-ost-sm': !noOffset}" *ngIf="errorItem.pattern">
		{{ fieldName }} {{ 'Modal.Form.Error.Invalid' | translate }}
	</p>
	<p class="c-text c-text--s3 c-text--sm" [ngClass]="{'u-ost-sm': !noOffset}" *ngIf="errorItem.email">
		{{ fieldName }} {{ 'Modal.Form.Error.Invalid' | translate }}
	</p>
	<p class="c-text c-text--s3 c-text--sm" [ngClass]="{'u-ost-sm': !noOffset}" *ngIf="errorItem.emailFree">
		{{ fieldName }} {{ 'Modal.Form.Error.In_Use' | translate }}
	</p>
	<p class="c-text c-text--s3 c-text--sm" [ngClass]="{'u-ost-sm': !noOffset}" *ngIf="errorItem.minlength">
		{{ fieldName }} {{ 'Modal.Form.Error.Too_Short' | translate }}
	</p>
	<p class="c-text c-text--s3 c-text--sm" [ngClass]="{'u-ost-sm': !noOffset}" *ngIf="errorItem.maxlength">
		{{ fieldName }} {{ 'Modal.Form.Error.Too_Long' | translate }}
	</p>
	<p class="c-text c-text--s3 c-text--sm" [ngClass]="{'u-ost-sm': !noOffset}" *ngIf="errorItem.passwordPattern">
		{{ 'Modal.Form.Error.Password_Pattern' | translate }}
	</p>
	<p class="c-text c-text--s3 c-text--sm" [ngClass]="{'u-ost-sm': !noOffset}" *ngIf="errorItem.passwordVerify">
		{{ fieldName }} {{ 'Modal.Form.Error.No_Match' | translate }} {{ 'Modal.Form.Label.Password' | translate | lowerCase }}
	</p>
</div>
